const React = require("react");
const T = React.PropTypes;

const Config = require("../Config.js")

const HistoricalFile = require("../types/HistoricalFile.js");

const HistoryItemGroup = require("./HistoryItemGroup.jsx");
const HistoryItem = require("./HistoryItem.jsx");
const TitledMessage = require("./TitledMessage.jsx");

const styles = {
    Section: {
        paddingTop: 50
    },
    Item: {
        margin: 20
    },
    EmptyList: {
        marginTop: 50,
        color: "#999"
    }
};

const HistoryList = React.createClass({
    props: {
        HistoryItems: T.arrayOf(HistoricalFile.Type)
    },
    render() {
        if (this.props.HistoryItems.length) {
            const items = _.chain(this.props.HistoryItems)
                .groupBy((h) => {
                    return h.Started.format("MMM D, YYYY");
                })
                .map((val, groupKey) => {
                    const children = val.map((h) => {
                        return (<HistoryItem style={styles.Item} key={h.PKID} File={h } />);
                    });

                    return (<HistoryItemGroup key={groupKey} style={styles.Section }
                                          Title={groupKey}>
                        {children}
                    </HistoryItemGroup>);
                })
                .value();

            return (<div>{items}</div>);
        }

        const message = `("Recent" = the past ${Config.RecentHistoryDays} days)`;

        return (<TitledMessage Title="Looks like you haven't uploaded anything recently."
                               Subtitle={message}
                               style={styles.EmptyList} />);
    }
});

module.exports = HistoryList;


// WEBPACK FOOTER //
// ./src/components/HistoryList.jsx